import { COUPON_FETCH_REQUEST, COUPON_FETCH_SUCCESS, COUPON_FETCH_FAILURE } from './types';
import { getReceipt } from '../Receipt/action';
import baseUrl from '../url'

const fetchCouponRequest = () => {
    return {
        type: COUPON_FETCH_REQUEST
    }
}

const fetchCouponSuccess = data => {
    return {
        type: COUPON_FETCH_SUCCESS,
        payload: data,
    }
}

const fetchCouponFailure = error => {
    return {
        type: COUPON_FETCH_FAILURE,
        payload: error,
    }
}


export const postCoupon = (slug, userCode) => {
    return (dispatch) => {
        dispatch(fetchCouponRequest());
        const token = localStorage.getItem('token');
        fetch(`${baseUrl}/check_coupon/${slug}`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    code: userCode
                })
            })
            .then(response => response.json())
            .then((response) => {
                dispatch(fetchCouponSuccess(response));
                dispatch(getReceipt(slug));
            })
            .catch((error) => {
                dispatch(fetchCouponFailure(error.message));
            })
    }
}